var linkify = require('linkifyjs/element');

$(function () {

    $(document).on('postcodeKeyPress', function (e) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $('#find-address').click();
            return false;
        }
    });

    $('#formChooseProduct').on('submit', function (e) {

        const $self = $(this);

        if (typeof window.finaliseCropForPersonalisedGift === 'function' && $('#buttonFinaliseCrop').is(':visible')) {
            e.preventDefault();
            window.finaliseCropForPersonalisedGift(function () {
                $('#formChooseProduct').submit();
            });
        } else {
            onSubmitChooseProductForm($self);
        }

        function onSubmitChooseProductForm($self) {
            var preventSubmit = false;

            if ($self.hasClass('byemail')) {
                if (!validateChooseProductSubmitForByEmail($self)) {
                    preventSubmit = true;
                }
            }

            if ($self.hasClass('bypost')) {
                if (!validateChooseProductSubmitForByPost($self)) {
                    preventSubmit = true;
                }
            }

            if ($('#containerPersonalisedGift').length && $('[data-product-id].selected')[0].hasAttribute('data-customisable')) {

                if (!updatePersonalisedEGiftChecksValidation()) {
                    preventSubmit = true;
                }

                if ($('#imgPersonalised').attr('src') === ''
                    || $('#imgPersonalised').data('is-placeholder') === true) {
                    preventSubmit = true;
                    $('#inputUploadedImage-validation-error-required').show();
                }

                $('#inputPermissionCheck').off('change');
                $('#inputPermissionCheck').on('change', function () {
                    updateValidationForPermissionCheck('inputPermissionCheck');
                });

                $('#inputPrivacyCheck').off('change');
                $('#inputPrivacyCheck').on('change', function () {
                    updateValidationForPermissionCheck('inputPrivacyCheck');
                });
            }

            if (preventSubmit) {
                e.preventDefault();
                window.snapToFirstInvalidElement();
            } else {
                $self.find('[type="submit"]').prop('disabled', true);
                showOrderProcessingPleaseWait();
            }

            function updatePersonalisedEGiftChecksValidation() {
                var check1 = updateValidationForPermissionCheck('inputPermissionCheck');
                var check2 = updateValidationForPermissionCheck('inputPrivacyCheck');
                return check1 && check2;
            }

            function updateValidationForPermissionCheck(checkId) {
                var $elem = $('#' + checkId);

                if ($elem.length) {
                    var checked = $elem.is(':checked');

                    if (checked) {
                        $elem.addClass('is-valid');
                        $elem.removeClass('is-invalid');
                    } else {
                        $elem.addClass('is-invalid');
                        $elem.removeClass('is-valid');
                    }

                    return checked;
                } else {
                    return true;
                }
            }
        }
    });

    const $valueTextbox = $('#textboxGiftCardPriceX');
    const $valueDropdown = $('#dropdownGiftCardPriceX');

    toggleAddAnotherDisplayBasedOnSelectedValue();

    $valueTextbox.on('change keyup', function () {
        toggleAddAnotherDisplayBasedOnSelectedValue();
    });
    $valueDropdown.on('change', function () {
        toggleAddAnotherDisplayBasedOnSelectedValue();
    });

    $valueTextbox.rules('add', {
        min: $valueTextbox.data('min-value'),
        max: $valueTextbox.data('max-value'),
        messages: {
            min: $valueTextbox.data('bad-amount-message'),
            max: $valueTextbox.data('bad-amount-message')
        }
    });

    $('.faq-container p').each(function () {
        linkify(this, {
            attributes: {
                rel: 'noreferrer'
            }
        });
    });

    $(document).on('click', '.landingPageFaqHeading', function () {
        const faqIndex = this.getAttribute('data-faqIndex')
        $('#landingPageFaqContent' + faqIndex).slideToggle();        
    });
});

function validateChooseProductSubmitForByPost($form) {
    EnterAddressManually();
    return $form.valid();
}

function validateChooseProductSubmitForByEmail($form) {

    var isValid = true;

    if (!$form.valid()) {
        isValid = false;
    }

    if (!window.validateDeliveryDateForByEmail()) {
        isValid = false;
    }

    return isValid;
}

function toggleAddAnotherDisplayBasedOnSelectedValue() {

    const current = parseInt($('#textboxGiftCardPriceX').val());

    const min = $('#textboxGiftCardPriceX').data('min-value');
    const maxOrder = $('#textboxGiftCardPriceX').data('max-order-value');
    const subtotal = $('#textboxGiftCardPriceX').data('current-subtotal');

    if ((current + subtotal + min) > maxOrder || (isNaN(current) && (min + min) > maxOrder)) {
        $('#btnProceedToPayment_AddAnother').hide();
    } else {
        $('#btnProceedToPayment_AddAnother').show();
    }
}

window.showOrderProcessingPleaseWait = function () {
    if (window.options.chooseProduct.showOrderProcessingPopup && $('#btnProceedToPayment').data('orderprocessing-url')) {
        $.ajax({
            url: $('#btnProceedToPayment').data('orderprocessing-url'),
            type: 'GET',
            cache: false,
            success: function (html) {
                $('#modalOrderProcessingPleaseWait').remove();

                const modalHtml = ModalTemplateHtml
                    .replace('{{MODAL_CONTENT}}', html);

                $('body').append(modalHtml);

                $('#modalOrderProcessingPleaseWait').modal();
            }
        });
    }
}

var ModalTemplateHtml =
    '<div id="modalOrderProcessingPleaseWait" class="modal order-processing-please-wait" tabindex="-1" role="dialog">' +
        '<div class="modal-dialog" role="document">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                        '<span aria-hidden="true">&times;</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body">' +
                    '{{MODAL_CONTENT}}' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';

window.selectCollectionEgiftType = function (collectionEgiftTypeId, isForSendToSelf) {
    $('#SelectedCollectionEgiftType').val(collectionEgiftTypeId);

    $('.collectionEgiftTypeButton').removeClass('selected');
    $('.collectionEgiftTypeButton-' + collectionEgiftTypeId).addClass('selected');

    if (collectionEgiftTypeId === 3) { 
        // Show additional fields for 2FA
        $('.gift-delivery-phone-number-container').show();
    }
    else{
        $('.gift-delivery-phone-number-container').hide();
    }

    if (isForSendToSelf === 'true') {
        $('#btnProceedToPayment').focus();
        $('#btnProceedToPayment')[0].scrollIntoView();
    }
}
